import React, { FunctionComponent } from 'react';
import { Link as GatsbyLink } from 'gatsby';
import { Box, Button, Center, HStack } from '@hover/blueprint';
import { motion, space } from '@hover/blueprint/foundation';
import { transitions } from 'polished';
import { INavbarItem } from '../../../interfaces/INavbarItems';
import NavbarLink from './NavbarLink';

export const HEADER_HEIGHT = space[1000];

export interface NavbarDesktopProps {
  links: INavbarItem[];
  isNavbarWhite: boolean;
  titleColor?: string;
  logo: JSX.Element;
}

const NavbarDesktop: FunctionComponent<NavbarDesktopProps> = ({
  links,
  isNavbarWhite,
  titleColor,
  logo,
}) => (
  <Box
    display="flex"
    flexDirection="column"
    width="100%"
    {...transitions(['border-color'], motion.easings[250])}
  >
    <Box
      display="flex"
      alignItems="center"
      height={HEADER_HEIGHT}
      justifyContent="space-between"
      pl={200}
      pr={300}
      gap={16}
    >
      {logo}
      <Center ml="auto" height="100%">
        <HStack spacing={12} height="100%">
          {links.map(link => (
            <NavbarLink
              titleColor={titleColor}
              as={GatsbyLink}
              to={link.to ?? ''}
              key={link.to}
              isLight={!isNavbarWhite}
              color="primary.600"
            >
              {link.label}
            </NavbarLink>
          ))}
        </HStack>
      </Center>
      <Box>
        <Button color="primary" as={GatsbyLink} to="/signup" size="large">
          Sign Up
        </Button>
      </Box>
    </Box>
  </Box>
);

export default NavbarDesktop;
